import React, { useState, useEffect, useContext } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import ContactUsTab from './tabs/ContactUsTab';
import ChatSupportTab from './tabs/ChatSupportTab';
import FAQTab from './tabs/FAQTab';
import RaiseTicketModal from './modals/RaiseTicketModal';
import TicketSuccessModal from './modals/TicketSuccessModal';
import { TicketContext } from '../../contexts/TicketContext';
import { TicketDto } from '../../services/ticketApi';
import '../../styles/pages/help-support.css';

type TabType = 'Contact Us' | 'Chat Support' | 'FAQ';

const HelpSupportPage: React.FC = () => {
  const ticketContext = useContext(TicketContext);

  const [activeTab, setActiveTab] = useState<TabType>('Contact Us');
  const [isRaiseTicketOpen, setIsRaiseTicketOpen] = useState(false);
  const [successRef, setSuccessRef] = useState('');
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [tickets, setTickets] = useState<TicketDto[]>([]);

  // Load user tickets on mount
  useEffect(() => {
    if (!ticketContext) return;
    ticketContext.getUserTickets().then(setTickets);
  }, []);

  const GoToChatSupport = () => {
    setActiveTab("Chat Support");
  };

  const handleTicketSubmit = async (ref: string, subject: string, priority: string, description: string) => {
    setSuccessRef(ref);
    setIsSuccessOpen(true);

    if (!ticketContext) return;

    const created = await ticketContext.createTicket({
      ticketSubject: subject,
      ticketPriority: priority,
      ticketDescription: description,
    });

    if (created) {
      setTickets((prev) => [created, ...prev]);
    }
  };

  return (
    <DashboardLayout>
      <div className="hs-container zoomOutLevel">

        {/* Header */}
        <div className="alerts-page-header">
          <div className="alerts-page-header-left">
            <h1 className="device-title">Help &amp; Support</h1>
            <p className="alerts-subtitle device-subtitle ml-0">Need help? Reach out to our support team or explore frequently asked questions.</p>
          </div>
          <div className="alerts-page-header-right">
            <button className="alerts-add-button" onClick={() => setIsRaiseTicketOpen(true)}>
              Raise Ticket
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="hs-tabs">
          {(['Contact Us', 'Chat Support', 'FAQ'] as TabType[]).map((tab) => (
            <button
              key={tab}
              className={`hs-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {activeTab === 'Contact Us' && <ContactUsTab tickets={tickets} />}
        {activeTab === 'Chat Support' && <ChatSupportTab />}
        {activeTab === 'FAQ' && <FAQTab GoToChatSupport={GoToChatSupport} />}

      </div>

      <RaiseTicketModal
        isOpen={isRaiseTicketOpen}
        onClose={() => setIsRaiseTicketOpen(false)}
        onSubmit={handleTicketSubmit}
      />

      <TicketSuccessModal
        isOpen={isSuccessOpen}
        refNumber={successRef}
        onClose={() => setIsSuccessOpen(false)}
      />
    </DashboardLayout>
  );
};

export default HelpSupportPage;
